import { render, staticRenderFns } from "./disputes-v2.vue?vue&type=template&id=1ca512d4"
import script from "./disputes-v2.vue?vue&type=script&lang=js"
export * from "./disputes-v2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports